<template>
  <section>
    <Header />
    <main class="main animated fadeIn faster" :class="{ 'expand-main': false }">
      <div class="row px-2">
        <div class="col-md-12">
          <div class="row d-flex flex-row px-0 mx-0">
            <div class="col-12 px-0">
              <h4 class="mb-3 ml-2">Data Monitoring</h4>
            </div>
          </div>

          <div
            class="d-flex align-items-center justify-content-center w-100 py-5"
            v-if="loading"
          >
            <LoadingSpinner />
          </div>
          <div v-else class="mx-0 pb-5 data-monitoring-stats">
            <div class="col-12 px-0">
              <div
                class="container-fluid w-100 mb-3 p-0 border bg-white rounded stats-wrapper"
              >
                <div class="d-flex flex-wrap">
                  <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="inputGroup-sizing-sm"
                        >Year</span
                      >
                    </div>
                    <treeselect
                      v-model="filters.yearFilter"
                      :options="yearOptions"
                      placeholder="Select year..."
                      class="form-control inline-table"
                    />
                  </div>
                  <div class="w-25 p-1 ml-auto">
                    <div class="col-md-12 d-flex justify-content-end my-2">
                      <button
                        class="btn btn-success"
                        :disabled="loading"
                        @click="applyFilters()"
                      >
                        <i class="icon-calendar-check-o mr-2"></i>
                        <small>Apply Filters</small>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 px-0 mb-3">
              <button
                class="btn btn-primary themed-button mr-2"
                @click="applyFilters('day')"
              >
                Day
              </button>
              <button
                class="btn btn-primary themed-button mr-2"
                @click="applyFilters('week')"
              >
                Week
              </button>
              <button
                class="btn btn-primary themed-button"
                @click="applyFilters('month')"
              >
                Month
              </button>
            </div>

            <div class="row">
              <div class="col-sm-12 mt-2 ">
                <h5 class="ml-3">New Contacts</h5>
                <div class="table-responsive">
                  <StatsTable
                    :statsClient="statsClient"
                    :statsType="statsType"
                    :statsDate="statsDate"
                    :showTotal="false"
                    :compactCells="true"
                  />
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 mt-2">
                <h5 class="ml-3">New Contacts Mobile</h5>
                <div class="table-responsive">
                  <StatsTable
                    :statsClient="statsClientMobile"
                    :statsType="statsTypeMobileContacts"
                    :statsDate="statsDateMobile"
                    :showTotal="false"
                    :compactCells="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import StatsTable from "@/components/Usages/StatsTable.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { bookersService } from "@/_services";

const DEFAULT_YEAR = 2026;
const TYPE_TABLE_CONTACTS = "contacts";
const TYPE_TABLE_CONTACTS_MOBILE = "contacts_mobile";

export default {
  name: "DataMonitoringStats",
  components: {
    LoadingSpinner,
    StatsTable,
    Treeselect,
  },
  computed: {
    yearOptions() {
      return (this.years || []).map((y) => ({ id: y.id, label: y.text }));
    },
  },
  data() {
    return {
      loading: true,
      periodMetrics: null,
      years: [
        { id: 2022, text: "2022" },
        { id: 2023, text: "2023" },
        { id: 2024, text: "2024" },
        { id: 2025, text: "2025" },
        { id: 2026, text: "2026" },
      ],
      filters: {
        yearFilter: DEFAULT_YEAR,
      },
      statsType: [
        {
          id: "contacts",
          label: "New Contacts",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "first_sent",
          label: "Email sent",
          format: "text",
          showQty: false,
          showTotal: false,
        },
      ],
      statsTypeMobileContacts: [
        {
          id: "contacts_mobile",
          label: "New Contacts Mobile",
          format: "qty",
          showQty: false,
          showTotal: false,
        },
        {
          id: "first_call",
          label: "Calls made",
          format: "text",
          showQty: false,
          showTotal: false,
        },
      ],
      statsClient: {},
      statsDate: [],
      statsClientMobile: {},
      statsDateMobile: [],
    };
  },
  created() {
    this.applyFilters();
  },
  mounted() {
    this.setDashboardHeader();
  },
  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    setDashboardHeader() {
      this.setCurrentRoute({
        page: "data-monitoring-stats",
        label: "Data Monitoring Statistics",
      });
      this.setCurrentRouteChild({ child: "" });
    },
    weekKeyFromFdate(fdate) {
      if (!fdate || typeof fdate !== "string") return fdate;
      const mWeek = fdate.match(/W(\d{1,2})/i);
      if (mWeek) return "W" + mWeek[1].padStart(2, "0");
      const mDay = fdate.match(/D(\d+)/i);
      if (mDay) return "D" + mDay[1].padStart(3, "0");
      return fdate;
    },
    sortStatsDateByWeek(statsDateArray) {
      if (!Array.isArray(statsDateArray)) return;
      statsDateArray.sort((a, b) => {
        const mDA = a.date.match(/^D(\d+)$/i);
        const mDB = b.date.match(/^D(\d+)$/i);
        if (mDA && mDB) {
          return parseInt(mDA[1], 10) - parseInt(mDB[1], 10);
        }
        const nA = parseInt((a.date.match(/^W(\d{1,2})/i) || [])[1], 10) || 0;
        const nB = parseInt((b.date.match(/^W(\d{1,2})/i) || [])[1], 10) || 0;
        if (nA || nB) return nA - nB;
        return String(a.date).localeCompare(String(b.date));
      });
    },
    applyFilters(period = null) {
      if (period != null) {
        this.periodMetrics = period;
      } else {
        this.periodMetrics = null;
      }
      this.loading = true;
      this.getData()
        .catch((e) => {
          console.error("Data monitoring stats:", e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildStatsFromTotals(totalsBy, statsType, getRaw) {
      const statsClient = {};
      const statsDate = [];
      statsType.forEach((statType) => {
        (totalsBy[statType.id] || []).forEach((item) => {
          const client_id = 0;
          const client_name = "";
          const fdate = this.weekKeyFromFdate(item.fdate);
          const raw = getRaw(statType, item);
          const key = `${statType.id}_${statType.format}`;
          let value;
          if (statType.format === "text") {
            value =
              raw !== undefined && raw !== null && raw !== ""
                ? String(raw)
                : null;
          } else {
            value =
              raw !== undefined && raw !== null && raw !== ""
                ? parseFloat(raw)
                : NaN;
          }

          if (!statsDate.find((field) => field.date === fdate)) {
            statsDate.push({ date: fdate });
          }

          if (statsClient[client_id] == undefined) {
            statsClient[client_id] = {};
            statsClient[client_id].name = client_name;
          }
          if (statsClient[client_id][fdate] == undefined) {
            statsClient[client_id][fdate] = {};
          }
          const y = statsClient[client_id][fdate];
          y[key] = value;
          statsClient[client_id][fdate] = y;
        });
      });
      this.sortStatsDateByWeek(statsDate);
      return { statsClient, statsDate };
    },
    getData() {
      const yearFilter =
        this.filters.yearFilter == null ? DEFAULT_YEAR : this.filters.yearFilter;
      const period =
        this.periodMetrics != null ? this.periodMetrics : null;
      const baseFilters = { yearFilter, period };

      this.statsClient = {};
      this.statsDate = [];
      this.statsClientMobile = {};
      this.statsDateMobile = [];

      return Promise.allSettled([
        bookersService.getDataMonitoringStats({
          ...baseFilters,
          typeTable: TYPE_TABLE_CONTACTS,
        }),
        bookersService.getDataMonitoringStats({
          ...baseFilters,
          typeTable: TYPE_TABLE_CONTACTS_MOBILE,
        }),
      ]).then((results) => {
        const resContacts =
          results[0].status === "fulfilled" ? results[0].value : null;
        const resMobile =
          results[1].status === "fulfilled" ? results[1].value : null;
        if (resContacts && resContacts.status == 200) {
          const built = this.buildStatsFromTotals(
            resContacts.result.totals_by_contacts || {},
            this.statsType,
            (statType, item) =>
              statType.id === "first_sent"
                ? item.percentage
                : item.new_contact_email
          );
          this.statsClient = built.statsClient;
          this.statsDate = built.statsDate;
        }
        if (resMobile && resMobile.status == 200) {
          const builtMobile = this.buildStatsFromTotals(
            resMobile.result.totals_by_contacts_mobile || {},
            this.statsTypeMobileContacts,
            (statType, item) =>
              statType.id === "first_call"
                ? item.percentage
                : item.new_contact_mobile
          );
          this.statsClientMobile = builtMobile.statsClient;
          this.statsDateMobile = builtMobile.statsDate;
        }
      });
    },
  },
};
</script>

<style scoped>
.data-monitoring-stats :deep(.table-responsive) {
  min-height: 150px;
}
</style>
